import { Link } from 'react-router-dom';

const stats = [
  { value: '2,200+', label: '收录影视作品' },
  { value: '35,000+', label: '月活影迷用户' },
  { value: '每日', label: '更新影视资讯' },
];

const features = [
  { icon: 'ri-compass-3-line', title: '智能推荐', desc: '按类型、年份、地区多维筛选，快速锁定想看的作品。' },
  { icon: 'ri-newspaper-line', title: '资讯聚合', desc: '一手片单动态与行业观察，看懂影视圈正在发生什么。' },
  { icon: 'ri-heart-3-line', title: '收藏追踪', desc: '随手收藏想看的影片，随时回到属于你的片单。' },
];

export default function AboutSection() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-portal px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14">
          <div className="relative">
            <div className="h-64 w-full overflow-hidden rounded-lg md:h-80 lg:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20cinema%20scene%2C%20comfortable%20sofa%20with%20soft%20blanket%20and%20glowing%20screen%20light%20in%20a%20dim%20room%2C%20amber%20and%20deep%20navy%20tones%2C%20inviting%20atmosphere%2C%20editorial%20photography&width=900&height=700&seq=about-1&orientation=squarish"
                alt="影视仓 观影场景"
                title="影视仓 发现精彩影视内容"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 left-5 hidden items-center gap-3 rounded-lg bg-primary-500 px-5 py-4 text-background-50 md:flex">
              <i className="ri-award-line text-2xl text-accent-300" />
              <div>
                <p className="font-heading text-sm font-bold">精选策划</p>
                <p className="text-xs text-background-200">编辑团队每周更新片单</p>
              </div>
            </div>
          </div>

          <div>
            <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-bold tracking-wider text-accent-600">
              <span className="h-1 w-4 rounded-full bg-accent-500" />
              关于影视仓
            </span>
            <h2 className="font-heading text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
              一个好内容，值得被更多人看见
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              影视仓希望成为你发现精彩影视内容的入口。我们不堆砌信息，而是通过清晰的分类、真实的口碑与编辑精选，帮你把时间留给真正值得看的故事。
            </p>

            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {features.map((item) => (
                <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-8">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <p className="font-heading text-2xl font-black text-primary-600">{stat.value}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>

            <Link
              to="/news"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              探索更多影视资讯
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}